import type { Candidate, Scenario } from '../api/personalAdvisory';

export const stateName: Record<string, string> = { queued: '생성 대기', running: '분석 중', complete: '완료', partial: '일부 분석', failed: '생성 실패', busy: '다른 리포트 생성 중', skipped: '일정 건너뜀', interrupted: '생성 중단' };
export const directionName = { LONG: '롱', SHORT: '숏', WAIT: '관망' };
export const horizonName = { intraday: '장중', swing: '스윙', investment: '투자' };
export const priorityName = { focus: '우선 검토', watch: '관찰', avoid: '진입 보류' };
export const assetGroups = [['all', '전체'], ['semi', '반도체'], ['korea', '한국·KORU'], ['crypto', '코인'], ['other', '기타 주식·ETF']] as const;

export function assetGroup(c: Candidate) {
  const base = c.instrument.replace(/USDT$/, '');
  if (['BTC', 'ETH', 'SOL'].includes(base)) return 'crypto';
  if (['KORU', '005930', '000660'].includes(base)) return 'korea';
  if (['SOXL', 'SOXS', 'SKHY', 'SMH', 'SOXX', 'NVDA', 'AMD', 'AVGO', 'TSM', 'MU', 'INTC', 'SNDK', 'WDC', 'ASML', 'ARM', 'AMAT', 'LRCX'].includes(base)) return 'semi';
  return 'other';
}

function future(value: string | null | undefined, now: number) {
  const time = value ? Date.parse(value) : NaN;
  return Number.isFinite(time) && time > now;
}

export function planState(s: Scenario, now = Date.now()) {
  if (!future(s.expires_at, now)) return 'expired';
  if (s.direction === 'WAIT') return 'wait';
  if (!s.levels) return 'unpriced';
  if (!future(s.numeric_expires_at, now)) return 'recheck';
  return 'priced';
}

export const planLabels = { expired: '시나리오 만료', wait: '관망 조건', unpriced: '가격 확인 대기', recheck: '가격 계획 만료', priced: '조건 충족 전 대기' };

export function selectScenario(c: Candidate, direction = 'all', horizon = 'all', now = Date.now()) {
  const rows = c.scenarios.filter(s => (direction === 'all' || s.direction === direction) && (horizon === 'all' || s.horizon === horizon));
  const rank = { priced: 0, unpriced: 1, recheck: 2, wait: 3, expired: 4 };
  return [...rows].sort((a, b) => rank[planState(a, now)] - rank[planState(b, now)])[0];
}

export function excerpt(text: string, length = 140) {
  return text.length > length ? text.slice(0, length).trimEnd() + '…' : text;
}

export function detailLink(id: string, search: string, instrument?: string) {
  const query = new URLSearchParams(search);
  query.set('report', id);
  return `/research/advisory/${encodeURIComponent(id)}?${query}${instrument ? `#advisory-${encodeURIComponent(instrument)}` : ''}`;
}
